import React from "react";

import { Section } from "../../../../App/Common/Styles/containers";
import { IFullCourse } from "../../../course-author/types";
import EditCoursePlayer from "./EditCoursePlayer";
import EditImmersiveBackground from "./EditImmersiveBackground";
import EditReadSpeaker from "./EditReadSpeaker";

interface IMediaSettingsProps {
  course: IFullCourse;
  courseId: string;
  userId: string;
}

const MediaSettings: React.FC<IMediaSettingsProps> = props => {
  const { course, courseId, userId } = props;
  return (
    <Section>
      <EditImmersiveBackground course={course} courseId={courseId} />
      <EditCoursePlayer course={course} courseId={courseId} userId={userId} />
      <EditReadSpeaker course={course} courseId={courseId} userId={userId} />
    </Section>
  );
};

export default MediaSettings;
